// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2I57x","empty":"ModalGraph_empty__2YooT"};